// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"b06105e3","551":"f96bb429"}[chunkId] + ".chunk.js";
};